function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _rect, _path, _path2, _path3, _rect2, _circle, _circle2, _path4, _rect3, _path5;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
import { Platform } from 'react-native';
import { createElement } from 'react';
var SvgAccidentAndInsurance = function SvgAccidentAndInsurance(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    x: 4,
    y: 4,
    fill: "#FFE4E6",
    rx: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FB7185",
    stroke: "#9F1239",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M60 18c-16 0-29 11-31 26h62c-2-15-15-26-31-26z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9F1239",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M60 44v16c0 6 5 8 9 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#9F1239",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m28 72 4-12c2-5 6-7 11-7h34c5 0 9 2 11 7l4 12"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 16,
    x: 26,
    y: 70,
    fill: "#FFF",
    stroke: "#9F1239",
    strokeWidth: 3,
    rx: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 88,
    r: 6,
    fill: "#FFE4E6",
    stroke: "#9F1239",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 88,
    r: 6,
    fill: "#FFE4E6",
    stroke: "#9F1239",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F43F5E",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "m84 58 6 6m0-6-6 6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 22,
    x: 86,
    y: 76,
    fill: "#FFF",
    stroke: "#F43F5E",
    strokeWidth: 2.5,
    rx: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F43F5E",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M91 82h8m-8 5h8m-8 5h5"
  })));
};
if (Platform.OS === 'web') {
  var ForwardRefNativeSvgIcon = /*#__PURE__*/React.forwardRef(SvgAccidentAndInsurance);
  SvgAccidentAndInsurance = function SvgAccidentAndInsurance(props, ref) {
    return /*#__PURE__*/createElement(ForwardRefNativeSvgIcon, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }));
  };
}
var ForwardRef = /*#__PURE__*/forwardRef(SvgAccidentAndInsurance);
export default ForwardRef;